import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="nested-questions"
export default class extends Controller {
  static targets = ["add_answer", "template","add_question", "question"]

  initialize() {
    this.questionIndex = parseInt(this.element.dataset.questionIndex, 10) || 0; // Initialize the question index variable
  }

  new_question(event) {
    console.log(this.questionIndex)
    event.preventDefault()  
    const questionIndex = this.questionIndex++
    //this.questionIndex = questionIndex + 1
    var content = this.questionTarget.innerHTML.replace(/Question_Index/g, questionIndex)
    this.add_questionTarget.insertAdjacentHTML('beforebegin', content)
  }

  remove_question(event) {
    event.preventDefault()
    let item = event.target.closest(".nested-questions")
    item.querySelector("input[name*='_destroy']").value = 1
    item.style.display = 'none'
  }

  new_answer(event) {
    event.preventDefault()  
    const answerContainer = event.target.closest("[data-answer='nested-answers']");
    const answerFields = answerContainer.querySelector("[data-target='nested-questions.template']");
    var answerContent = answerFields.innerHTML.replace(/Answer_Index/g, new Date().valueOf())
    const addAnswerTarget = answerContainer.querySelector("[data-target='nested-questions.add_answer']");
    addAnswerTarget.insertAdjacentHTML('beforebegin', answerContent)
  }

  remove_answer(event) {
    event.preventDefault()
    let item = event.target.closest(".nested-fields")
    item.querySelector("input[name*='_destroy']").value = 1
    item.style.display = 'none'
  }


}
